import { memo, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { OutletIProps } from '../../../components/sitebase/Base.types';
import GlofasNewsSearch from './GlofasNewsList';
import NewsSearchForm from './GlofasNewsSearchForm';
import setTitle from '../../../components/common/SetTitle';

export default memo(function GlofasNewsPage() {
    const { setExtraMenuLinks } = useOutletContext<OutletIProps>();
    const [searchParams, setSearchParams] = useSearchParams();

    const query = searchParams.get('query') || '';
    const startDate = searchParams.get('start_date') || '';
    const endDate = searchParams.get('end_date') || '';
    const category = searchParams.get('category') || '';
    const page = parseInt(searchParams.get('page') || '1');

    useEffect(() => {
        setExtraMenuLinks([]);
        setTitle('News');
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [setExtraMenuLinks]);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const next = new URLSearchParams();
        const q = data.get('query') as string;
        const sd = data.get('start_date') as string;
        const ed = data.get('end_date') as string;
        const cat = data.get('category') as string;
        if (q) next.set('query', q);
        if (sd) next.set('start_date', sd);
        if (ed) next.set('end_date', ed);
        if (cat) next.set('category', cat);
        next.set('page', '1');
        setSearchParams(next);
    }

    function handleReset() {
        setSearchParams({});
    }

    function handlePageChange(newPage: number) {
        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set('page', String(newPage));
            return next;
        });
    }

    return (
        <Container>
            <h3 style={{ borderBottom: '1px solid orange' }}>GloFAS News</h3>
            <NewsSearchForm
                query={query}
                startDate={startDate}
                endDate={endDate}
                category={category}
                onSubmit={handleSubmit}
                onReset={handleReset}
            />
            <GlofasNewsSearch
                query={query}
                startDate={startDate}
                endDate={endDate}
                category={category}
                page={page}
                onPageChange={handlePageChange}
            />
        </Container>
    );
});

